import { render, staticRenderFns } from "./EnvironmentWatermark.vue?vue&type=template&id=2f948f0b&scoped=true&"
import script from "./EnvironmentWatermark.vue?vue&type=script&lang=js&"
export * from "./EnvironmentWatermark.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentWatermark.vue?vue&type=style&index=0&id=2f948f0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f948f0b",
  null
  
)

export default component.exports